import { render } from "./Terms.vue.js?vue&type=template&id=5390bd8c!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Terms.vue?vue&type=template&id=5390bd8c"
import script from "./Terms.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Terms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__